<template>
  <div class="mx-3">
    <div class="bg-white border-radius--light py-2 rounded">
      <div class="row mb-4">
        <div class="col-md-6 mb-3 assistence-details-label">
          <em class="fas fa-info-circle text-orange mr-2" />
          <span>Detalles de Asistencia</span>
        </div>
        <div class="col-md-6 text-right">
          <span
            class="bg-secondary-1 p-2 px-4 badge badge-pill font-weight-bold font-13"
          >
            Fórmula de Cálculo: $0.40 x Millas x Acompañante
          </span>
        </div>
      </div>
      <div v-if="showAssistanceService" class="d-flex mt-n3 ml-4">
        <div>
          <div class="color-secondary-6 font-14">Acompañante:</div>
          <div class="d-flex align-items-center mt-2">
            <em class="fas fa-user-friends color-gray-7 font-13" />
            <span class="color-black font-12 ml-2">
              {{ assistanceService.hasCompanion ? 'Si' : 'No' }}
            </span>
          </div>
        </div>
        <div class="ml-5">
          <div class="color-secondary-6 font-14">Millaje:</div>
          <div class="d-flex align-items-center mt-2">
            <em class="fas fa-car color-gray-7 font-13" />
            <span class="color-black font-12 ml-2">
              {{ assistanceService.mileage }}
            </span>
          </div>
        </div>
        <div class="ml-5">
          <div class="color-secondary-6 font-14">Costo Diario:</div>
          <div class="d-flex align-items-center mt-1">
            <span class="fa-stack fa-1x color-secondary-25 font-11 mr-1">
              <em class="fas fa-circle fa-stack-2x" />
              <em class="fas fa-dollar-sign fa-stack-1x fa-inverse" />
            </span>
            <div :class="amountClass(assistanceService.serviceCost)">
              {{ assistanceService.serviceCost }}
            </div>
          </div>
        </div>
        <div class="ml-5">
          <div class="d-flex align-items-center mt-3">
            <action-button
              v-if="showUpdateMillage"
              i="fas fa-redo-alt"
              variant="success"
              @click="updateMillageCompanion"
            >
              Actualizar Millaje/Acompañante
            </action-button>
          </div>
        </div>
      </div>
      <div class="row px-3 mt-4 mt-md-0 mt-sm-4">
        <div
          v-for="(item, index) in normalAssistances"
          :key="`calendar-row-${index}`"
          class="col-md-2 col-sm col-6 calendar-card"
        >
          <calendar-card :value="item" />
        </div>
      </div>
      <div>
        <div class="row mt-4">
          <div
            v-if="adjustAssistances.length > 0"
            class="col-md-12 mb-4 assistence-details-label"
          >
            <em class="fas fa-info-circle text-orange mr-2" />
            <span>Detalles de Ajustes</span>
          </div>
        </div>
        <div v-if="adjustAssistances.length > 0" class="row mb-4 ml-1">
          <div class="col">
            <period-selector
              :periods="adjustPeriods"
              :selected-period="selectedPeriod"
              @on-select-period="onSelectedPeriodHandler"
            />
          </div>
        </div>
        <div class="row px-3 mt-4 mt-md-0 mt-sm-4">
          <div
            v-for="(item, index) in adjustAssistances"
            :key="`calendar-row-${index}`"
            class="col-md-2 col-sm col-6 calendar-card"
          >
            <calendar-card class="calendar-card" :value="item" />
          </div>
        </div>
      </div>
      <div
        v-show="
          assistanceSummary.peiAnalysisServiceId == serviceTypeEnum.educativo &&
            assistanceSummary.isManualAssistanceFlag == false
        "
        class="row bg-secondary-29 pt-3 mx-n3 rounded"
      >
        <div
          class="col-9 col-md-3 bg-white d-flex align-items-center p-2 pl-4 mr-3 mb-3 py-3 w-25"
        >
          <check-box
            v-model="isAnalized"
            class="w-auto"
            :disabled="isAnalized"
            text=""
          />
          <p class="color-gray-7 font-16 font-weight-bold m-0 pt-1">
            Marcar record como
            <span class="color-orange font-weight-bold font-italic font-16">
              Analizado
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CalendarCard, PeriodSelector } from '../../components';
import { analyzedmark as _analyzedmark } from '@/modules/shared/scholarship.api.js';
import alertMixin from '@/mixins/alert.mixin';
import { getUser } from '@/core/auth';
import serviceType from '@/views/scholarship/attendance/utils/serviceTypeEnum.js';
import ActionButton from 'ActionButton';
import assistanceApprovalStatus from '@/utils/constants/assistanceApprovalStatus.js';

export default {
  name: 'AssistanceDetails',
  components: {
    CalendarCard,
    PeriodSelector,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    selectedPeriod: {
      type: String,
      default: () => '',
    },
    adjustPeriods: {
      type: Array,
      default: () => [],
    },
    normalAssistances: {
      type: Array,
      default: () => [],
    },
    adjustAssistances: {
      type: Array,
      default: () => [],
    },
    assistanceSummary: {
      type: Object,
      default: () => {},
    },
    assistanceService: {
      type: Object,
      default: () => {},
    },
    showAssistanceService: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    isAnalized: false,
    canceled: false,
    serviceTypeEnum: serviceType,
  }),
  computed: {
    amountClass() {
      return (total) =>
        Math.sign(total) > 0
          ? 'font-18 color-secondary-31 font-weight-bold'
          : 'font-18 color-secondary-28 font-weight-bold';
    },
    showUpdateMillage() {
      return (
        this.assistanceSummary.assistanceApprovalStatusCd ==
          assistanceApprovalStatus.Pendiente &&
        this.assistanceSummary.peiAnalysisServiceId !== 134
      );
    },
  },
  watch: {
    isAnalized: function(value) {
      if (!this.canceled) {
        this.setAnalyzedMark(value);
      }
      this.canceled = false;
    },
  },
  created() {
    this.initCheckBox();
  },
  methods: {
    onSelectedPeriodHandler(item) {
      this.$emit('on-select-adjusment-period', item);
    },
    async initCheckBox() {
      if (this.assistanceSummary.analyzedById != null) {
        this.canceled = true;
        this.isAnalized = true;
      }
    },
    async setAnalyzedMark(value) {
      const user = await getUser();
      const responseModal = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea marcar el record de pago como Analizado?',
        'Sí',
        'No'
      );
      if (responseModal) {
        let parameter = {
          assistanceSummaryId: this.assistanceSummary.assistanceSummaryId,
          analyzedById: value ? user.profile.sub : null,
        };
        await _analyzedmark(parameter);
        this.assistanceSummary.analyzedById = user.profile.sub;
        this.ShowToast(
          'Proceso exitoso',
          'El record fue marcado como Analizado exitosamente.',
          'success'
        );
      } else {
        this.canceled = true;
        this.isAnalized = !value;
      }
    },
    updateMillageCompanion() {
      this.$emit('on-update-milleage-companion', this.assistanceSummary);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

@media only screen and (max-width: 768px) {
  span,
  p {
    font-size: map-get($fontsSize, 'font-12') !important;
  }

  .calendar-card__wrapper {
    width: unset;
  }

  .calendar-card {
    padding-right: 5px;
    padding-left: 10px;
  }
}

.assistence-details-label {
  color: map-get($colors, 'gray-7');
}
</style>
